(() => {
  const root = document.querySelector('[data-wv5-root]');
  if (!root) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = root.querySelector('[data-wv5-header]');
  const reveals = [...root.querySelectorAll('.wv5-reveal')];
  const parallax = root.querySelector('[data-wv5-parallax]');
  const drift = root.querySelector('[data-wv5-drift]');

  root.classList.add('wv5-motion-ready');
  requestAnimationFrame(() => root.classList.add('wv5-loaded'));

  if (reduced) {
    reveals.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { root: null, threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

  reveals.forEach((el) => observer.observe(el));

  let queued = false;
  const onScroll = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (header) header.classList.toggle('is-scrolled', y > 28);
      if (parallax) {
        const rect = parallax.parentElement.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
        parallax.style.setProperty('--wv5-parallax-y', `${(progress - 0.5) * 54}px`);
      }
      if (drift) drift.style.setProperty('--wv5-drift-x', `${Math.min(160, y * 0.055)}px`);
      queued = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
